import React, { useContext, useEffect } from "react";
import { useParams, useHistory } from "react-router-dom";
import { Button } from "@material-ui/core";
import MyContext from "../context/MyContext";
import axios from "axios";
import ProductItem from "./ProductItem";
import Slider from "./Slider";

const DetailProduct = (props) => {
  const history = useHistory()
  const context = useContext(MyContext);
  const { detailProduct, setDetailProduct, products, cart, setCart, user } = context;
  const params = useParams();

  const addCart = async (product) => {
    const check = cart.every((item) => {
      return item._id !== product._id;
    });

    if (check) {
      setCart([...cart, { ...product, quantity: 1 }]);
      await axios.patch("/users/addcart",{ cart: [...cart, { ...product, quantity: 1 }] });
      
    } else {
      alert("This product has been added to cart.");
    }
  };

  const checkUser = (detailProduct) => {
    if (!user) {
      alert("Please login");
      history.push("/login");
    } else {
      addCart(detailProduct);
    }
  };

  useEffect(() => {
    if (params.id) {
      products.forEach((product) => {
        if (product._id === params.id) setDetailProduct(product);
      });
    }
  }, [params.id, products, setDetailProduct]);

  if (detailProduct.length === 0) return null;

  return (
    <>
      <div className="detail">

        <Slider data={detailProduct.images}></Slider>
        
        <div className="box-detail">
          <div className="row">
            <h2>{detailProduct.title}</h2>
            <h6>#id: {detailProduct.product_id}</h6>
          </div>
          <span>{detailProduct.price} €</span>
          <p>{detailProduct.description}</p>
          <p>{detailProduct.content}</p>
          <p>Sold: {detailProduct.sold}</p>
          <Button
            to="/cart"
            className="cart"
            onClick={() => checkUser(detailProduct)}
          >
            Buy Now
          </Button>
        </div>
      </div>

      <div>
        <h2>Related products</h2>
        <div className="products">
          {products.map((product) => {
            return product.category === detailProduct.category ? (
              <ProductItem key={product._id} product={product} />
            ) : null;
          })}
        </div>
      </div>
    </>
  );
};

export default DetailProduct;
